import React from "react";
import { useNavigate } from "react-router-dom";
import MBelow from "../../../assets/images/budget.png";
import lekki from "../../../assets/images/lekki.png";
import vi from "../../../assets/images/vi.png";
import surulere from "../../../assets/images/surulere.png";
import MAbove from "../../../assets/images/luxury.png";
import yaba from "../../../assets/images/yaba.png";

import "./krentManaged.css";

const cards = [
  {
    label: "1M & Below",
    img: MBelow,
    size: "big",
  },
  { label: "Lekki", img: lekki, size: "small" },
  { label: "Victoria Island", img: vi, size: "small" },
  { label: "Surulere", img: surulere, size: "small" },
  { label: "Yaba", img: yaba, size: "small" },
  { label: "1M & Above", img: MAbove, size: "big" },
];

interface CardItemProps {
  label: string;
  img: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  isSideCard?: boolean;
}

const CardItem = ({
  label,
  img,
  className,
  style,
  onClick,
  isSideCard = false,
}: CardItemProps) => (
  <div
    className={`position-relative overflow-hidden rounded-4 ${className}`}
    style={{ cursor: "pointer", ...style }}
    onClick={onClick}
  >
    <img
      src={img}
      alt={label}
      className={`w-100 h-100 object-fit-cover card-image ${isSideCard ? "card-image-side" : "card-image-middle"}`}
    />
    <div
      className="position-absolute bottom-0 start-0 w-100 "
      style={{
        background: "linear-gradient(to top, rgba(0,0,0,.5), transparent)",
        height: "60%",
        borderRadius: "16px",
        backgroundClip: "text",
      }}
    />
    <span
      className="position-absolute bottom-0 start-0 p-3 text-white fw-500"
      style={{ fontSize: ".95rem", textShadow: "0 1px 6px rgba(0,0,0,.5)" }}
    >
      {label}
    </span>
  </div>
);

export default function KrentSection() {
  const navigate = useNavigate();

  const handleCardClick = (label: string) => {
    const locationCards = ["Lekki", "Victoria Island", "Surulere", "Yaba"];

    if (locationCards.includes(label)) {
      const key =
        label === "Victoria Island"
          ? "victoria+island"
          : label.toLowerCase().replace(/\s+/g, "");
      navigate(`/properties/?key=${encodeURIComponent(key)}`);
    } else if (label === "1M & Above") {
      navigate("/properties/?key=above1m");
    } else if (label === "1M & Below") {
      navigate("/properties/?key=below1m");
    }
  };

  return (
    <div className="container py-5">
      <h2
        className="fw-semibold mb-4 font-display"
        style={{ fontSize: "1.5rem" }}
      >
        Krent managed Properties in Nigeria
      </h2>

      <div className="row g-3">
        <div className="col-12 col-md-3">
          <CardItem
            label={cards[0].label}
            img={cards[0].img}
            className="w-100"
            style={{ height: "420px" }}
            onClick={() => handleCardClick(cards[0].label)}
            isSideCard
          />
        </div>

        <div className="col-12 col-md-6">
          <div className="row g-3">
            {cards.slice(1, 5).map((card) => (
              <div className="col-6" key={card.label}>
                <CardItem
                  label={card.label}
                  img={card.img}
                  className="w-100"
                  style={{ height: "200px" }}
                  onClick={() => handleCardClick(card.label)}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="col-12 col-md-3">
          <CardItem
            label={cards[5].label}
            img={cards[5].img}
            className="w-100"
            style={{ height: "420px" }}
            isSideCard
            onClick={() => handleCardClick(cards[5].label)}
          />
        </div>
      </div>
    </div>
  );
}
